import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'primeng/components/common/messageservice';

import { Contrato, ContratoForm, TipoContrato } from '../../../base/vo/contrato';
import { ModalSucessoComponent } from '../../../modal/modal-sucesso/modal-sucesso.component';
import { AdminContratosService } from '../admin-contratos.service';


@Component({
  selector: 'app-admin-contratos-novo',
  templateUrl: './admin-contratos-novo.component.html',
  styleUrls: ['./admin-contratos-novo.component.scss'],
})
export class AdminContratosNovoComponent implements OnInit, OnDestroy {

  @ViewChild('modalSucesso')
  public modalSucesso: ModalSucessoComponent;

  public step = 1;
  public loading = true;
  public saving = false;
  public searching = false;

  public label = 'Editar Contrato';
  public formGroupContrato: FormGroup;

  public contrato: Contrato;
  public tiposContrato: TipoContrato[];

  private subs: Subscription[] = [];
  private id: number;

  constructor(
    private readonly adminContratoService: AdminContratosService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly messageService: MessageService
  ) { }

  ngOnInit() {
    if (this.router.url.includes('vincular')) {
      this.step = 2;
    } else if (this.router.url.includes('editar')) {
      this.step = 1;
    } else {
      this.label = 'Criar Contrato';
    }

    this.subs.push(
      this.route.params
        .pipe(
          tap((params) => {
            if (params['id']) {
              this.id = +params['id'];
              this.getContrato();
            } else {
              this.loading = false;
            }
          })
        )
        .subscribe()
    );

    this.getTiposContrato();
  }

  ngOnDestroy() {
    this.subs.forEach((subscription) => subscription.unsubscribe());
  }

  private getTiposContrato() {
    this.subs.push(
      this.adminContratoService
        .getTiposContrato()
        .pipe(
          tap(response => {
            this.tiposContrato = response;
          })
        )
        .subscribe()
    );
  }

  private getContrato() {
    this.loading = true;
    this.searching = true;

    this.subs.push(
      this.adminContratoService
        .getContrato(this.id)
        .pipe(
          tap(response => {
            this.contrato = response;
            this.loading = false;
            this.searching = false;
          })
        )
        .subscribe()
    );
  }

  public submitContrato(contratoForm: ContratoForm) {
    this.loading = true;
    this.saving = true;
    if (this.id) {
      this.editContrato(contratoForm);
    } else {
      this.saveContrato(contratoForm);
    }
  }

  public saveContrato(contratoForm: ContratoForm) {
    this.subs.push(
      this.adminContratoService
        .saveContrato(contratoForm)
        .pipe(
          tap(response => {
            this.contrato = response;
            this.router.navigate([
              `admin/contratos/vincular/${this.contrato.id}`,
            ]);
          })
        )
        .subscribe()
    );
  }

  public editContrato(contratoForm: ContratoForm) {
    this.subs.push(
      this.adminContratoService
        .editContrato(this.id, contratoForm)
        .pipe(
          tap(response => {
            if(this.contrato.acoes.vincular) {
              this.router.navigate([
                `admin/contratos/vincular/${this.id}`,
              ]);
            } else {
              this.router.navigate([`admin/contratos`]);
            }
            
          }),
        )
        .subscribe()
    );
  }

  public submitVinculo(contrato: Contrato) {
    this.loading = true;
    this.saving = true;

    this.subs.push(
      this.adminContratoService
        .postVinculo(contrato.id, contrato.urlAnexoVinculo)
        .pipe(
          tap(
            (response) => {
              this.loading = false;
              this.saving = false;
              this.modalSucesso.openDialog();
            },
            errorResponse => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
            }
          )
        )
        .subscribe()
    );
  }

  public confirmSuccessModal() {
    this.modalSucesso.closeDialog();
    this.router.navigate(['/admin/contratos']);
  }

  get stateName(): string {
    if (this.saving) {
      return 'save';
    }

    if (this.searching) {
      return 'searching';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/contratos/admin-contratos-novo/admin-contratos-novo.component.ts